var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"E-mail"),React.createElement("path",{"d":"M18.125 0H1.875A1.877 1.877 0 000 1.875v11.25C0 14.159.841 15 1.875 15h16.25A1.877 1.877 0 0020 13.125V1.875A1.877 1.877 0 0018.125 0zm0 1.25c.085 0 .166.018.24.048L10 8.548l-8.365-7.25a.622.622 0 01.24-.048h16.25zm0 12.5H1.875a.625.625 0 01-.625-.625V2.619l8.34 7.228a.624.624 0 00.82 0l8.34-7.228v10.506c0 .345-.28.625-.625.625z","fillRule":"nonzero","key":1})]);
}

Mail.defaultProps = {"viewBox":"0 0 20 15"};

module.exports = Mail;

Mail.default = Mail;
